// Produção: somente eventos reais. Overrides antigos do navegador não ativam a prévia.
// Para testes futuros, habilite explicitamente esta configuração no código.
export const CELEBRATION_PREVIEW = { enabled: false };
export function celebrationPreviewEnabled() {
  if (!CELEBRATION_PREVIEW.enabled) return false;
  try {
    const override = localStorage.getItem("lesvita.celebrationPreview");
    if (override !== null) return override === "1";
  } catch {
    /* armazenamento indisponível */
  }
  return CELEBRATION_PREVIEW.enabled;
}
export function celebrationPresentation(data, preview) {
  if (!preview) return data;
  return {
    ...data,
    prevLevel: 9,
    newLevel: 10,
    leveledUp: true,
    prevCurrentLevelXp: 480,
    prevNextLevelXp: 500,
    newCurrentLevelXp: 100,
    newNextLevelXp: 550,
    xpGained: 120,
    pontosGanhos: 50,
    pontosAntes: 1200,
    preview: true,
  };
}
export function shouldCelebrateStreak(
  data,
  preview = celebrationPreviewEnabled()
) {
  return (
    preview ||
    (data?.STREAK_CELEBRATION_ELIGIBLE === true && Number(data?.streak) > 0)
  );
}
export function projectCelebration(xp, earned = 0) {
  const prevLevel = Number(xp?.LEVEL) || 1;
  const prevCurrentLevelXp = Number(xp?.CURRENT_LEVEL_XP) || 0;
  const prevNextLevelXp = Number(xp?.NEXT_LEVEL_XP) || 100;
  let newLevel = prevLevel,
    newCurrentLevelXp = prevCurrentLevelXp + Number(earned || 0),
    newNextLevelXp = prevNextLevelXp;
  while (newCurrentLevelXp >= newNextLevelXp) {
    newCurrentLevelXp -= newNextLevelXp;
    newLevel++;
    newNextLevelXp += 50;
  }
  return {
    prevLevel,
    prevCurrentLevelXp,
    prevNextLevelXp,
    newLevel,
    newCurrentLevelXp,
    newNextLevelXp,
    leveledUp: newLevel > prevLevel,
    xpGained: Number(earned) || 0,
  };
}

/**
 * Nível vindo do SERVIDOR (`levelUp` do award: {nivelAntes, nivelDepois,
 * leveledUp, xpAntes:{atual,proximo}, xpDepois:{atual,proximo}}) no formato
 * que a celebração usa. O servidor é a fonte da verdade: a projeção local
 * (projectCelebration) lia um snapshot que o listener do XP_VITA às vezes já
 * tinha atualizado, e o "Subiu de nível" sumia.
 *
 * `reserva` = projeção local, usada só para o que o servidor não mandou
 * (resposta de versão antiga do servidor, ou evento repetido sem as barras).
 */
export function celebracaoDoServidor(levelUp, reserva = {}) {
  if (!levelUp || !Number.isFinite(Number(levelUp.nivelDepois))) return reserva;
  const antes = levelUp.xpAntes || null;
  const depois = levelUp.xpDepois || null;
  return {
    ...reserva,
    prevLevel: Number(levelUp.nivelAntes) || reserva.prevLevel || 1,
    newLevel: Number(levelUp.nivelDepois),
    leveledUp: levelUp.leveledUp === true,
    ...(antes ? {
      prevCurrentLevelXp: Number(antes.atual) || 0,
      prevNextLevelXp: Number(antes.proximo) || 100,
    } : {}),
    ...(depois ? {
      newCurrentLevelXp: Number(depois.atual) || 0,
      newNextLevelXp: Number(depois.proximo) || 100,
    } : {}),
  };
}
